<template>
  <div class="course-page">
    <v-card class="course-card">
      <div class="course-header">
        <div class="course-header__copy">
          <div class="course-title">Courses</div>
          <div class="course-subtitle">Manage course records and accreditation.</div>
        </div>
        <v-btn v-if="canCreateCourse == true" class="course-add-button" depressed @click="AddCourse()">
          <v-icon left>mdi-plus-circle</v-icon>
          <span>Add Course</span>
        </v-btn>
      </div>

      <v-tabs v-model="tab" background-color="transparent" color="basil" grow class="course-tabs">
        <v-tab v-for="tabItem in tabItems" :key="tabItem">
          {{ tabItem }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="tabItem in tabItems" :key="tabItem">
          <div v-if="tabItem == 'Non Accredited Courses'">
            <v-card class="mx-4" flat>
              <v-card-title class="course-filter">
                <v-row align="center" class="course-filter__row" no-gutters>
                  <v-col cols="12" md="4" class="course-filter__col">
                    <v-text-field
                        v-model="nonAccName"
                        append-icon="mdi-magnify"
                        hide-details
                        label="Search course name"
                        single-line
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="course-filter__col">
                    <v-autocomplete
                        v-model="nonAccCpd"
                        :clearable="clearable"
                        :elevation="1"
                        :items="CPD_PROVIDERS"
                        :loading="cpdProviderLoading"
                        :searchable="searchable"
                        item-text="trainingCenterName"
                        item-value="id"
                        label="search course owners"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-data-table
                  :headers="nonAccreditedHeaders"
                  :items="nonAccreditedCourses.rows"
                  :loading="nonAccreditedLoading"
                  :options.sync="nonAccOptions"
                  :server-items-length="nonAccreditedCourses.count"
                  class="course-table elevation-1"
                  loading-text="Loading... please wait">
                <template v-slot:[`item.actions`]="{ item }">
                  <div class="course-action-group">
                    <v-tooltip bottom>
                      <template v-if="canViewCourse" v-slot:activator="{ on }">
                        <v-icon class="course-action-icon" @click="viewCourse(item)" v-on="on">mdi-eye</v-icon>
                      </template>
                      <span>View Course</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-if="canEditCourseItem(item)" v-slot:activator="{ on }">
                        <v-icon class="course-action-icon" @click="editCourse(item, false)"
                                v-on="on">mdi-circle-edit-outline
                        </v-icon>
                      </template>
                      <span>Edit Course</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-if="canAccreditCourse" v-slot:activator="{ on }">
                        <v-icon class="course-action-icon" @click="editCourse(item, true)"
                                v-on="on">mdi-circle-edit-outline
                        </v-icon>
                      </template>
                      <span>Accredit Course</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
          <div v-if="tabItem == 'Accredited Courses'">
            <v-card class="mx-4" flat>
              <v-card-title class="course-filter">
                <v-row align="center" class="course-filter__row" no-gutters>
                  <v-col cols="12" md="4" class="course-filter__col">
                  <v-text-field
                      v-model="accName"
                      append-icon="mdi-magnify"
                      hide-details
                      label="Search course name"
                      single-line
                  ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="course-filter__col">
                  <v-autocomplete
                      v-model="accCpd"
                      :clearable="clearable"
                      :elevation="1"
                      :items="CPD_PROVIDERS"
                      :loading="cpdProviderLoading"
                      :searchable="searchable"
                      item-text="trainingCenterName"
                      item-value="id"
                      label="search course owners"
                  ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-data-table
                  :headers="headers"
                  :items="accreditedCourses.rows"
                  :loading="accreditedLoading"
                  :options.sync="accOptions"
                  :server-items-length="accreditedCourses.count"
                  class="course-table elevation-1"
                  loading-text="Loading... please wait">
                <template v-slot:[`item.courseCode`]="{ item }">
                  <label for="item">
                    <barcode :height="50" v-bind:value="item.courseCode">
                      Sorry, rendering failed!
                    </barcode>
                  </label>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <div class="course-action-group">
                    <v-tooltip bottom>
                      <template v-if="canViewCourse" v-slot:activator="{ on }">
                        <v-icon class="course-action-icon" @click="viewCourse(item)" v-on="on">mdi-eye</v-icon>
                      </template>
                      <span>View Course</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template
                          v-if="canRollbackCourse(item)"
                          v-slot:activator="{ on }"
                      >
                        <v-icon
                            class="course-action-icon"
                            @click="openRollbackDialog(item)"
                            v-on="on"
                        >
                          mdi-undo-variant
                        </v-icon>
                      </template>
                      <span>Rollback to Unaccredited</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template
                          v-if="canShowRollbackBlocked(item)"
                          v-slot:activator="{ on }"
                      >
                        <v-icon class="course-action-icon course-action-icon--disabled" v-on="on">
                          mdi-undo-variant
                        </v-icon>
                      </template>
                      <span>Cannot rollback: CPD Activity exists</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>

            </v-card>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <template>
      <v-dialog v-model="dialog" persistent width="60%">
        <v-card class="course-dialog-card">
          <v-card-title class="course-dialog__title" primary-title>{{ title }}

            <v-spacer></v-spacer>

            <v-btn class="course-dialog__close" icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>
          <HrdAddCourse v-if="dialog" :changeCourseOwnerNo="changeCourseOwnerNo"
                        :changeTCourseUsedNo="changeTCourseUsedNo"
                        :course="course" @close="closeDialog()"
                        @registerOrUpdateCourse="registerOrUpdateCourse"></HrdAddCourse>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="detailDialog" persistent width="60%">
        <v-card class="course-dialog-card">
          <v-card-title class="course-dialog__title" primary-title>
            {{ title }}
            <v-spacer></v-spacer>
            <v-btn class="course-dialog__close" icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>
          <HrdDetailCourse v-if="detailDialog" :course="course"></HrdDetailCourse>
        </v-card>
      </v-dialog>
    </template>
    <confirmationModal
        v-if="rollbackDialog"
        title="Rollback Course"
        @confirmed="confirmRollback"
        @close="closeRollbackDialog"
    ></confirmationModal>
  </div>
</template>


<script>
import HrdAddCourse from "./hrd-add-course";
import HrdDetailCourse from "./hrd-course-detail";
import {CourseServcie} from "./course.service";
import {getUser} from "@/utils/helper";
import {canViewCourseCatalog, canAccreditCourses} from "@/utils/courseAccess";
import VueBarcode from 'vue-barcode';
import {TrainingCenterService} from "@/components/TrainingCenter/training_center.service";
import confirmationModal from "../../common/confirmation-modal.vue";

export default {
  components: {
    HrdAddCourse,
    HrdDetailCourse,
    confirmationModal,
    'barcode': VueBarcode
  },

  data() {
    return {
      dialog: false,
      detailDialog: false,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      // Accredited
      accreditedLoading: false,
      accreditedCourses: [],
      accOptions: {
        page: 1,
        itemsPerPage: 10
      },
      accName: null,
      accCpd: null,
      headers: [
        {text: "Course Name", value: "courseName"},
        {text: "Course Code", value: "courseCode"},
        {text: "Continuing Education Unit(CEU)", value: "continualEducationUnit"},
        {text: "Course Owner", value: "courseOwner.trainingCenterName"},
        {text: "Course Accreditor", value: "courseAccreditor.accreditorName"},
        {text: "Accreditation Date", value: "courseAccreditationDate"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      // Non-Accredited
      nonAccreditedLoading: false,
      nonAccreditedCourses: [],
      nonAccOptions: {
        page: 1,
        itemsPerPage: 10
      },
      nonAccName: null,
      nonAccCpd: null,
      nonAccreditedHeaders: [
        {text: "Course Name", value: "courseName"},
        {text: "Continuing Education Unit(CEU)", value: "continualEducationUnit"},
        {text: "Course Owner", value: "courseOwner.trainingCenterName"},
        {text: "Course Creater", value: "createdBy.firstName"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      //
      CPD_PROVIDERS: [],
      course: null,
      title: "",
      loading: false,
      changeTCourseUsedNo: null,
      changeCourseOwnerNo: null,
      cpdProviderLoading: false,
      cpdProviderValue: null,
      tab: null,
      searchable: true,
      clearable: true,
      courseNameValue: null,
      tabItems: ["Non Accredited Courses", "Accredited Courses"],
      rollbackDialog: false,
      rollbackTarget: null,
    };
  },
  async beforeMount() {
    this.fetchAccreditedCourse();
    this.fetchNonAccreditedCourse();

    this.cpdProviderLoading = true;
    const trainingCenterResp = await TrainingCenterService.getTrainingCentersDrp();
    this.CPD_PROVIDERS = trainingCenterResp.data;
    this.cpdProviderLoading = false;
  },
  computed: {
    canCreateCourse() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Course" && permission.canCreate
      );
    },
    canViewCourse() {
      return canViewCourseCatalog(getUser()) || (getUser()?.permissions || []).some(
          (permission) =>
              permission.menuItem.menuItemName == "Course" && permission.canRead
      );
    },
    canAccreditCourse() {
      return canAccreditCourses(getUser());
    },
  },
  watch: {
    nonAccOptions: {
      handler() {
        this.fetchNonAccreditedCourse();
      },
      deep: true
    },
    accOptions: {
      handler() {
        this.fetchAccreditedCourse();
      },
      deep: true
    },
    nonAccName: function (val) {
      this.nonAccName = val == '' ? null : val;
      this.fetchNonAccreditedCourse();
    },
    accName: function (val) {
      this.accName = val == '' ? null : val;
      this.fetchAccreditedCourse();
    },
    nonAccCpd: function (val) {
      this.nonAccCpd = val == '' ? null : val;
      this.fetchNonAccreditedCourse();
    },
    accCpd: function (val) {
      this.accCpd = val == '' ? null : val;
      this.fetchAccreditedCourse();
    },
  },
  methods: {
    isCourseCreator(item) {
      const user = getUser();
      const userId = user?.data?.id;
      const creatorId = item?.createdById ?? item?.createdBy?.id;
      if (!userId || !creatorId) {
        return false;
      }
      return Number(userId) === Number(creatorId);
    },
    canEditCourseItem(item) {
      return this.$can("course","edit") && item?.isAccredited !== true && this.isCourseCreator(item);
    },
    isCourseAccreditor(item) {
      const userAccreditorId = getUser()?.data?.accreditorId;
      return Boolean(
          userAccreditorId &&
          Number(item?.courseAccreditorId) === Number(userAccreditorId)
      );
    },
    canRollbackCourse(item) {
      return (
          this.$can("course","rollbackAccreditation",this.canAccreditCourse) &&
          this.isCourseAccreditor(item) &&
          item?.hasActiveCpdActivity === false
      );
    },
    canShowRollbackBlocked(item) {
      return (
          this.$can("course","rollbackAccreditation",this.canAccreditCourse) &&
          this.isCourseAccreditor(item) &&
          item?.hasActiveCpdActivity === true
      );
    },
    async fetchAccreditedCourse() {
      this.accreditedLoading = true;
      const {page, itemsPerPage} = this.accOptions;
      let searchParams = '?isAccredited=True';
      itemsPerPage > 0 && (searchParams += `&page=${page}&pageSize=${itemsPerPage}`);
      this.accCpd !== null && (searchParams += '&trainingCenterId=' + this.accCpd);
      this.accName !== null && (searchParams += '&name=' + this.accName);
      const res = await CourseServcie.getCourses(searchParams);
      if (res.status === 200) {
        this.accreditedLoading = false;
        this.accreditedCourses = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching accredited course reports, Please try Again!"
        );
      }
    },
    async fetchNonAccreditedCourse() {
      this.nonAccreditedLoading = true;
      const {page, itemsPerPage} = this.nonAccOptions;
      let searchParams = '?isAccredited=False';
      itemsPerPage > 0 && (searchParams += `&page=${page}&pageSize=${itemsPerPage}`);
      this.nonAccCpd !== null && (searchParams += '&trainingCenterId=' + this.nonAccCpd);
      this.nonAccName !== null && (searchParams += '&name=' + this.nonAccName);
      const res = await CourseServcie.getCourses(searchParams);
      if (res.status === 200) {
        this.nonAccreditedLoading = false;
        this.nonAccreditedCourses = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching non accredited course reports, Please try Again!"
        );
      }
    },

    async fetchCourseList() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let searchParams = '';
      this.cpdProviderValue !== null && (searchParams += '&trainingCenterId=' + this.cpdProviderValue);
      this.courseNameValue !== null && (searchParams += '&name=' + this.courseNameValue);

      const res = await CourseServcie.getCourseList(
          page,
          itemsPerPage,
          searchParams
      );
      if (res.status === 200) {
        this.loading = false;
        const returnedCorses = res.data;
        this.nonAccreditedCourses = returnedCorses.filter(course => {
          return course.isAccredited == false || course.isAccredited == true
        })
        this.courses = returnedCorses.filter(course => {
          return course.isAccredited == true
        })
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching courses, Please try Again!"
        );
      }
    },
    async refreshCourseTables() {
      await Promise.all([
        this.fetchNonAccreditedCourse(),
        this.fetchAccreditedCourse(),
      ]);
    },
    async viewCourse(item) {
      if (!item?.id) {
        this.course = item;
        this.detailDialog = true;
        this.title = "Course Detail";
        return;
      }
      try {
        const res = await CourseServcie.getCourse(item.id);
        this.course = res?.data || item;
      } catch (error) {
        this.course = item;
      }
      this.detailDialog = true;
      this.title = "Course Detail";
    },
    AddCourse() {
      this.course = null;
      this.dialog = true;
      this.title = "Add Course";
    },
    editCourse(item, isAccrediting) {
      if (isAccrediting && !this.canAccreditCourse) {
        this.$toast.error("Only an accreditor or MOH user can accredit courses.");
        return;
      }
      if (!isAccrediting && !this.canEditCourseItem(item)) {
        this.$toast.error(item?.isAccredited === true
            ? "Accredited courses cannot be edited."
            : "Only the course creator can edit this course.");
        return;
      }
      this.course = {
        ...item,
        isAccrediting,
      };
      this.title = isAccrediting ? "Accredit Course" : "Edit Course";
      this.dialog = true;
      this.changeTCourseUsedNo = 0;
      this.changeCourseOwnerNo = 0;
    },
    closeDialog() {
      this.dialog = false;
      this.detailDialog = false;
      this.refreshCourseTables();
    },
    openRollbackDialog(item) {
      this.rollbackTarget = item;
      this.rollbackDialog = true;
    },
    closeRollbackDialog() {
      this.rollbackDialog = false;
      this.rollbackTarget = null;
    },
    async confirmRollback() {
      if (!this.rollbackTarget?.id) {
        this.closeRollbackDialog();
        return;
      }
      try {
        const payload = {
          isAccredited: false,
          courseAccreditorId: null,
          courseAccreditationDate: null,
          courseCode: null,
        };
        const res = await CourseServcie.update(this.rollbackTarget.id, payload);
        if (res.status === 201 && res.data.status === 200) {
          this.$toast.success(res.data.message || "Course rolled back successfully.");
          this.fetchAccreditedCourse();
          this.fetchNonAccreditedCourse();
        } else {
          this.$toast.error(res.data?.message || "Unable to rollback course, please try again.");
        }
      } catch (error) {
        this.$toast.error(
            error?.response?.data?.message ||
            "Unable to rollback course, please try again."
        );
      } finally {
        this.closeRollbackDialog();
      }
    },
    buildCoursePayload(course) {
      return {
        courseName: course.courseName ?? null,
        courseCode: course.courseCode ?? null,
        continualEducationUnit: course.continualEducationUnit ?? null,
        courseDuration: course.courseDuration ?? null,
        courseLevelId: course.courseLevelId ?? null,
        courseOwnerId: course.courseOwnerId ?? null,
        courseAccreditorId: course.courseAccreditorId ?? null,
        courseAccreditationDate: course.courseAccreditationDate ?? null,
        targetAudienceIds: course.targetAudienceIds ?? [],
        passingScore: course.passingScore ?? null,
        courseLevels: course.courseLevels ?? [],
        isAccredited: course.isAccredited ?? false,
        isAccrediting: course.isAccrediting ?? false,
      };
    },
    buildCourseFormData(course) {
      const payload = this.buildCoursePayload(course);
      const formData = new FormData();

      Object.entries(payload).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        if (Array.isArray(value) || typeof value === "object") {
          formData.append(key, JSON.stringify(value));
          return;
        }
        formData.append(key, value);
      });

      if (course.courseContentFile) {
        formData.append("courseContent", course.courseContentFile);
      }

      return formData;
    },
    async registerOrUpdateCourse(course) {
      const payload = this.buildCourseFormData(course);

      try {
        const res = course.editMode
            ? await CourseServcie.update(course.id, payload)
            : await CourseServcie.create(payload);

        if (res?.data?.status === 200) {
          this.$toast.success(res.data.message);
          this.dialog = false;
          await this.refreshCourseTables();
          return;
        }

        this.$toast.error(
            res?.data?.message ||
            (course.editMode
                ? "Unable to update course, please try again."
                : "Unable to create course, please try again.")
        );
      } catch (error) {
        this.$toast.error(
            error?.response?.data?.message ||
            (course.editMode
                ? "Unable to update course, please try again."
                : "Unable to create course, please try again.")
        );
      }
    }
  },
};
</script>
<style scoped>
.course-page {
  padding: 24px;
  background: #f5f7fb;
  min-height: 100%;
}

.course-card {
  border-radius: 0 0 12px 12px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.course-header {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) auto;
  align-items: center;
  gap: 16px;
  padding: 24px 28px;
}

.course-header__copy {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.course-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
}

.course-subtitle {
  font-size: 14px;
  color: #475569;
}

.course-add-button {
  background: #1976d2 !important;
  border-color: #1976d2 !important;
  color: #ffffff !important;
  text-transform: none;
  font-weight: 600;
}

.course-tabs {
  border-top: 1px solid rgba(15, 23, 42, 0.06);
}

.course-filter {
  padding: 8px 16px 0;
}

.course-filter__row {
  margin: 0;
  gap: 12px;
}

.course-filter__col {
  padding: 8px 12px;
}

.course-table {
  border-radius: 0 0 12px 12px;
}

.course-action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.course-action-group .v-tooltip {
  display: inline-flex;
}

.course-action-icon {
  color: #1976d2 !important;
}

.course-action-icon--disabled {
  color: #94a3b8 !important;
  cursor: not-allowed;
}

.course-dialog-card {
  border-radius: 10px;
  overflow: hidden;
}

.course-dialog__title {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #3a4f63;
  color: #ffffff;
  padding: 20px 24px;
}

.course-dialog__close {
  color: #ffffff !important;
}

.course-dialog__close .v-icon {
  color: #ffffff !important;
}

.basil {
  background-color: #eff6ff !important;
}

.basil--text {
  color: #356859 !important;
}

@media (max-width: 700px) {
  .course-page {
    padding: 12px;
  }

  .course-header {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 20px;
  }

  .course-add-button {
    width: 100%;
    justify-content: center;
  }
}
</style>
